export enum AuthQueryParams {
    MUST_SIGNUP = 'must_signup',
    EXISTING_ACCOUNT = 'existing_account',
    INVITE_UUID = 'invite_uuid',
    NEXT = 'next',
    IDP = 'idp',
    REASON = 'reason',
    DIFFERENT_METHOD = 'different_method',
}

export enum AuthReasonOptions {
    AuthStateForbidden = 'AuthStateForbidden',
    AuthForbidden = 'AuthForbidden',
}
